module.exports = __webpack_public_path__ + "img/qrcode_bg.48f72e7c.png";